module.exports = __webpack_public_path__ + "img/the mansions two beauties.18562f23.png";